import React from 'react';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button } from '../../../components/ui';

const QDFFormHeader = ({ onBack, isEditing = false, showBack = true, title }) => (
  <div className="mb-6 flex items-start justify-between gap-4 border-b border-border pb-4">
    <div className="min-w-0">
      <h1 className="text-xl font-semibold text-foreground sm:text-2xl">
        {title || (isEditing ? 'Edit QDF report' : 'QDF maintenance form')}
      </h1>
      <p className="mt-0.5 text-sm text-muted-fg">
        {isEditing
          ? 'Update the existing record.'
          : 'Document and asset fields are filled automatically where possible.'}
      </p>
    </div>

    {showBack && (
      <Button variant="ghost" icon={ArrowBack} onClick={onBack} className="shrink-0">
        <span className="hidden sm:inline">Back</span>
      </Button>
    )}
  </div>
);

export default QDFFormHeader;
